import {
    useMemo,
} from 'react'
import SkyNetPagination, {
    useSkyNetPagination,
} from 'app/shared-components/SkyNetPagination'
import useRequestTable from 'app/hooks/useRequestTable'
import request from 'app/requests/Container/Container.requests'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import RichTable from 'app/shared-components/RichTableReduxWrapper'
import useLabel from 'app/hooks/useLabel'

import {
    ContainerAutomatedSensorCheck,
} from '../../containers.types'
import getColumns from './AutomatedSensorChecks.columns'
import useStyles from './AutomatedSensorChecks.style'

type Props = {
    id: string,
}

const AutomatedSensorChecks = ({
    id: serialNumber,
}: Readonly<Props>) => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()
    const paginationOptions = useSkyNetPagination(25)

    const {
        onParamsChange,
        loadData,
    } = useRequestTable<{ data: ContainerAutomatedSensorCheck[] }>({
        config: request.getSensorChecks,
        params: {
            serialNumber,
        },
        key: RequestKeys.getContainerSensorChecks,
        keepPreviousData: true,
        withPagination: Boolean(paginationOptions),
        paginationOptions,
    })
    const columns = useMemo(() => {
        return getColumns(l)
    }, [l])

    return (
        <>
            <RichTable
                configName="SensorChecksTable"
                name="AutomatedSensorChecks"
                load={loadData}
                onParamsChange={onParamsChange}
                columns={columns}
                className={classes.tableContainer}
            />
            <div className={classes.paginationWrapper}>
                <SkyNetPagination
                    total={paginationOptions.matches}
                    rowsPerPage={paginationOptions.rows}
                    page={paginationOptions.page}
                    onChange={paginationOptions.onChange}
                />
            </div>
        </>
    )
}

export default AutomatedSensorChecks
